import callApi from "@web-monorepo/infra/callApi";
import createActionCreator from "@web-monorepo/infra/createActionCreator";
import createAsyncActions from "@web-monorepo/infra/createAsyncActions";
import createWaitableSaga from "@web-monorepo/infra/createWaitableSaga";
import { APIResponse } from "@web-monorepo/shared/api/apiTypesHelper";
import { SagaIterator } from "redux-saga";
import { takeEvery, call, put } from "redux-saga/effects";
import { Response } from "superagent";
import { createAction as makeFeatureSwitchRequest } from "./fetchFeatureSwitches";
import getUser from "pods/auth/util/getUser";

export const [FETCH_SESSION, FETCH_SESSION_DONE] = createAsyncActions("auth/fetchSession");

export const fetchSession = createActionCreator(FETCH_SESSION);

export type SessionResponse = APIResponse<"/api/session", "get">;

// we only use these three types of users in this code
export type UserType = Extract<SessionResponse["type"], "student" | "parent" | "teacher">;
export type Session = Omit<SessionResponse, "type"> & {
  type: UserType;
};
export type User = SessionResponse["student"] | SessionResponse["parent"] | SessionResponse["teacher"];
type UserConfig = SessionResponse["userConfig"];

type ResponseWithApiError = Omit<Response, "body"> & {
  apiError?: string | null;
  body: Session;
};

type FetchSessionDoneAction = {
  type: string;
  error?: string;
  payload: {
    response: Session;
  };
};

type SessionState = {
  didFetchSession: boolean;
  user: User | null;
  userConfig: UserConfig | null;
  error?: {
    email: boolean;
    password: boolean;
  };
};

const fetch = createWaitableSaga(function* (): SagaIterator {
  const res: ResponseWithApiError = yield call(callApi, {
    method: "GET",
    path: `/api/session`,
    query: { includeExtras: "mqttChannels,metaData" },
  });

  if (res.status !== 200) {
    return yield put({
      type: FETCH_SESSION_DONE,
      error: true,
      payload: res.apiError,
    });
  }

  const entity = res.body[res.body.type];
  yield put(makeFeatureSwitchRequest({ teacherId: entity?._id || "" }));
  yield put({
    type: FETCH_SESSION_DONE,
    payload: {
      response: res.body,
    },
  });
});

export function fetchSessionHandler(state: SessionState, action: FetchSessionDoneAction) {
  if (action.type === FETCH_SESSION_DONE) {
    if (action.error) {
      return {
        ...state,
        didFetchSession: true,
        user: null,
        userConfig: null,
      };
    }

    return {
      ...state,
      didFetchSession: true,
      user: getUser(action.payload.response),
      userConfig: action.payload.response.userConfig,
      error: {
        email: false,
        password: false,
      },
    };
  }

  return state;
}

export function* fetchSessionSaga() {
  yield takeEvery(FETCH_SESSION, fetch);
}
